import { asyncAction, asyncReducer, asyncSelector } from '../utils'
import { ExtraCampaignsServiceProvider } from '../../api/extra-campaigns'

const ExtraCampaignsService = ExtraCampaignsServiceProvider()
const name = 'allowedNamesAlternativeCampaigns'

export default (id) => (asyncAction(
  name,
  ExtraCampaignsService.allowedNamesAlternativeCampaigns
))

export const reducer = asyncReducer(name)
export const selector = asyncSelector(name)



// WEBPACK FOOTER //
// ./src/store/extra-campaign/allowedNamesAlternativeCampaigns.js